import { render, staticRenderFns } from "./cost.vue?vue&type=template&id=1386715a&scoped=true"
import script from "./cost.vue?vue&type=script&lang=js"
export * from "./cost.vue?vue&type=script&lang=js"
import style0 from "./cost.vue?vue&type=style&index=0&id=1386715a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386715a",
  null
  
)

export default component.exports